export default __webpack_public_path__ + "static/media/NationalWebLF-Semibold.2e805ff3.eot";